// Static drawing images removed — media comes from WooCommerce product attachments.

export const drawingImages = {};
